import {Component} from "react"
import {connect} from "react-redux"
import PropTypes from "prop-types"
import {isEqual} from "lodash"

import {BlockNavigationActions} from "./index"

class BlockRefresh extends Component {
  static propTypes = {
    blockNavigation: PropTypes.func.isRequired,
    unblockNavigation: PropTypes.func.isRequired,
    updateComponent: PropTypes.func.isRequired,
    block: PropTypes.bool,
    msg: PropTypes.string.isRequired,
    children: PropTypes.element
  }

  static defaultProps = {
    block: false,
    msg: "You have unsaved information, are you sure you want to leave this page?",
    children: null
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.setBlock()
  }

  componentWillUnmount() {
    setTimeout(this.props.unblockNavigation)
  }

  componentDidUpdate(prevProps) {
    const {children, updateComponent} = this.props

    if (prevProps.block !== this.props.block) {
      return this.setBlock()
    } else if (!isEqual(prevProps.children, children)) {
      updateComponent(children)
    }
  }

  setBlock = () => {
    const {block, msg, children, blockNavigation, unblockNavigation} = this.props

    if (block) {
      blockNavigation(msg, children)
    } else {
      unblockNavigation()
    }
  }

  render() {
    return null
  }
}

const actions = (dispatch) => {
  return {
    unblockNavigation: () => dispatch(BlockNavigationActions.unblock(true)),
    blockNavigation: (msg, children) => dispatch(BlockNavigationActions.block(msg, children)),
    updateComponent: (children) => dispatch(BlockNavigationActions.update(children))
  }
}

export default connect(null, actions)(BlockRefresh)
